import React, { useContext, useEffect, useMemo, useRef, } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { BsPlusCircle } from "react-icons/bs";


import { Button, Card, Checkbox, Grid, Group, SegmentedControl, Space, Title, ThemeIcon } from "@mantine/core";
import { useLocalStorage, useSessionStorage } from "@mantine/hooks";
// import KYCStatusFilter from "../../components/KYCStatusFilter";

import { IconEye } from "@tabler/icons-react";
import { CustomClaims, TransactionStatusCode, TypesenseTransaction } from "../../types";
import { MyUserDataContext } from "../../contexts";
import TransactionsInstantSearch from "../../components/transactions_instant_search";
import { RefreshButton, RefreshButtonRef } from "../../components/transactions_instant_search";

interface ActionsComponentProps {
    typesenseTransactionObg: TypesenseTransaction;
}


const SubscriptionAndRedemptionList = () => {
    const userData = useContext(MyUserDataContext);
    const customClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims | undefined;
    const isOperations = !!customClaims?.oper;
    const [viewAllTransactions, setViewAllTransactions] = useSessionStorage<boolean>({
        key: `transactions_view_all_${userData.user?.uid ?? "anon"}`,
        defaultValue: false,
        getInitialValueInEffect: false,
    });
    const [storedSource, setStoredSource] = useLocalStorage<string>({
        key: `transactions_source_${userData.user?.uid ?? "anon"}`,
        defaultValue: "all",
        getInitialValueInEffect: false,
    });
    const sourceFilter = storedSource === "portfolio" || storedSource === "kfhtrade" ? storedSource : "all";
    const defaultFilter = [
        isOperations && !viewAllTransactions
            ? `tags.transactionStatus.code:=${TransactionStatusCode.waiting_for_execution}`
            : "",
        sourceFilter !== "all" ? `source:=${sourceFilter}` : "",
    ].filter(Boolean).join(" && ");
    const navigate = useNavigate();
    const location = useLocation();
    const { refreshTransactionsIn } = location.state || {};
    const refreshRef = useRef<RefreshButtonRef | null>(null);

    const handleExternalRefresh = () => {
        if (refreshRef.current) {
            refreshRef.current.refresh();
        }
    };

    useEffect(() => {
        if (refreshTransactionsIn) {
            const timer = setTimeout(() => {
                // Action to perform after delay
                console.log('Refreshing Transactions...');
                handleExternalRefresh();
                // Place your code here to refresh Transactions or any other intended action
            }, refreshTransactionsIn);

            // Clean up the timer when the component unmounts or if the value of refreshTransactionsIn changes
            return () => clearTimeout(timer);
        }
    }, [refreshTransactionsIn]); // Dependency array, re-run effect if refreshTransactionsIn changes

    const RenderActionsDetails = ({ typesenseTransactionObg }: ActionsComponentProps) => {
        const navigate = useNavigate();
        return <Group>
            <ThemeIcon color="blue" variant="light" onClick={() => {
                navigate("/transactions/" + typesenseTransactionObg.id, { state: typesenseTransactionObg })
            }}><IconEye size={16} /></ThemeIcon>
        </Group>

    }
    const searchableTransactions = useMemo(() =>
        <>
            <Group justify="space-between">
                <Title>Transactions</Title>
                <Button
                    leftSection={<BsPlusCircle />}
                    onClick={() => {
                        navigate("/transactions/add");
                    }}
                >
                    {" "}
                    Add Transactions{" "}
                </Button>
            </Group>

            <Space h="xl" />
            <Card shadow="sm" p="lg" radius="md" withBorder>
                <Grid justify="space-between">
                    <Grid.Col>
                        <SegmentedControl
                            aria-label="Transaction source"
                            value={sourceFilter}
                            onChange={setStoredSource}
                            data={[
                                { label: "Portfolio", value: "portfolio" },
                                { label: "KFH Trade", value: "kfhtrade" },
                                { label: "All", value: "all" },
                            ]}
                        />
                    </Grid.Col>
                    {isOperations && <Grid.Col>
                        <Checkbox
                            label="View all transactions"
                            checked={viewAllTransactions}
                            onChange={(event) => setViewAllTransactions(event.currentTarget.checked)}
                        />
                    </Grid.Col>}
                    <Grid.Col>
                        <TransactionsInstantSearch
                            additionalChildren={<RefreshButton ref={refreshRef} />}
                            ActionsDetailView={RenderActionsDetails}
                            indexName={import.meta.env.VITE_TYPESENSE_TRANSACTION_COLLECTION!}
                            defaultFilter={defaultFilter}

                        />
                    </Grid.Col>
                </Grid>
            </Card>
        </>,
        // eslint-disable-next-line 
        [isOperations, viewAllTransactions, sourceFilter, defaultFilter, setStoredSource]);



    return (
        <>
            {searchableTransactions}
        </>
    );
};

const TransactionsList = () => {


    return (
        <main style={{ padding: "1rem 0" }}>
            {/* {searchableTransactions} */}
            <SubscriptionAndRedemptionList />
        </main>
    );
};

export default TransactionsList;
